import React from 'react';
import { SectionHeader } from '../components/UI';
import { useInView } from '../hooks/useInView';
import styles from './Mentor.module.css';

const CREDENTIALS = [
  /*{ icon: '🎓', text: 'Google Ads Certified' },
  { icon: '📘', text: 'Meta Blueprint Certified' }, */
  { icon: '💼', text: '3+ Years Industry Experience' },
  { icon: '🏢', text: 'Worked with 50+ Brands' },
];

export default function Mentor() {
  const [ref, inView] = useInView();

  return (
    <section className={styles.section} id="mentor">
      <div className={styles.container}>
        <SectionHeader
          label="Your Mentor"
          title="Learn from someone who actually runs campaigns — not just teaches them"
          center
        />

        <div className={`${styles.card} ${inView ? styles.visible : ''}`} ref={ref}>
          {/* Left: Photo + credentials */}
          <div className={styles.left}>
            <div className={styles.avatarWrap}>
              <img
                src="/mentor.jpg"
                alt="Mr. Anant Athare – Co-Founder, DigiMint WebTroopz LLP"
                className={styles.avatar}
              />
              <div className={styles.avatarGlow} />
            </div>
            <div className={styles.name}>Mr. Anant Athare</div>
            <div className={styles.role}>Co-Founder, DigiMint WebTroopz LLP</div>

            <div className={styles.creds}>
              {CREDENTIALS.map((c, i) => (
                <div key={i} className={styles.cred}>
                  <span className={styles.credIcon}>{c.icon}</span>
                  {c.text}
                </div>
              ))}
            </div>
          </div>

          {/* Right: Bio */}
          <div className={styles.right}>
            <h3 className={styles.bioTitle}>Why your instructor makes all the difference</h3>
            <p className={styles.bio}>
              Most course instructors are full-time educators. At Digimint, your mentor is an
              active digital marketer who runs real campaigns for real clients — right now, today.
              That means the curriculum stays current, examples are real and the advice is grounded
              in what actually works (not what worked in 2021).
            </p>
            <p className={styles.bio}>
              With 3+ years across e-commerce, services, B2B and local brands, your mentor brings
             genuine ad-spend experience across multiple industries. You get the credentials and the real-world battle scars.
            </p>
            <p className={styles.bio}>
              Small batches mean you're not a face in a crowd. You'll have direct access via
              live sessions, WhatsApp, and 1-on-1 doubt clearing whenever you need it.
            </p>
            <div className={styles.quote}>
              "I built this course because I was hiring graduates who couldn't run a basic
              campaign. I want to change that — one practical student at a time."
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
